async function getFullList(api) {
	try {
		const response = await fetch(api);
		const data = await response.json();
		return data;
	} catch (error) {
		console.error("Error fetching data:", error);
		return [];
	}
}

function filterList(data) {
	// Define the allowed exchanges for stocks
	const allowedExchanges = ["NASDAQ", "NYSE", "OTC", "PNK", "AMEX"];

	// Filter the array based on the type and allowed exchanges
	return data.filter(
		(item) =>
			item.type === "stock" &&
			allowedExchanges.includes(item.exchangeShortName)
	);
}

//delete from the list if it's not a stock and from NASDAQ, NYSE, OTC, PNK, AMEX (US stock exchanges)
export async function fetchUSStockList() {
	const fullList = await getFullList(
		"https://financialmodelingprep.com/api/v3/stock/list?apikey=0OlXvaWXwLdmZ7CM5vXed2rGuuyn17gy"
	);

	const usStockList = filterList(fullList);

	return usStockList;
}

//   const fs = require('fs');

// fetchUSStockList().then(usStocks => fs.writeFile('stockList.js', JSON.stringify(usStocks, null, 2), (err) => {
// 	if (err) {
// 	  console.error("Error writing to file:", err);
// 	} else {
// 	  console.log("Output successfully written to stockList.js");
// 	}
//   }));

// function findLargerTicker(list) {
// 	let maxSymbolChar = 0;
// 	let largerSymbol = "a";
// 	let maxNameChar = 0;
// 	let largerName = "a";

// 	for (let i = 0; i < list.length; i++) {
// 		if (maxSymbolChar < list[i].symbol.length) {
// 			maxSymbolChar = list[i].symbol.length;
// 			largerSymbol = list[i].symbol;
// 		}
// 		if (!list[i].name) {
// 			console.log(list[i].name);
// 		} else {
// 			if (maxNameChar < list[i].name.length) {
// 				maxNameChar = list[i].name.length;
// 				largerName = list[i].name;
// 			}
// 		}
// // 	}
// 	console.log("Max symbol length:", maxSymbolChar);
// 	console.log("Larger symbol:", largerSymbol);
// 	console.log("Max name length:", maxNameChar);
// 	console.log("Larger name:", largerName);

// Max symbol length: 8
// Larger symbol: OUST-WTA
// Max name length: 155
// Larger name: Social Leverage Acquisition Corp I Redeemable warrants, each whole warrant exercisable for one share of Class A common stock at an exercise price of $11.50
// also a lot of null names???
// }

// fetchUSStockList().then((usStocks) => findLargerTicker(usStocks));
